// extracted by mini-css-extract-plugin
export default {"starRatings":"starRatings__184-F","ratingsWrapper":"ratingsWrapper__jL2ig","stars":"stars__16zLx","starWrapper":"starWrapper__1OM9e","starOutlinePadding":"starOutlinePadding__2LzuG"};